import React, { useState, useEffect } from "react";
import i18n from "i18n";

import { Checkbox, FormControl, Container, Chip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { TextField, Autocomplete } from "@mui/material";

import { LocationService } from "services/LocationService";
import { BusinessNodeService } from "services/BusinessNodeService";

import { isMobile } from "helpers/Mobile";

import filterData from "../data/filters";

import SelectFilter from "components/MainApp/atoms/Filters/SelectFilter";
import TwoOptionFilter from "components/MainApp/atoms/Filters/TwoOptionFilter";
import DropdownFilter from "components/MainApp/atoms/Filters/DropdownFilter";
import DateInput from "components/MainApp/atoms/Forms/DateInput";

import DropDownTreeSelect from "./DropDownTreeSelect/DropDownTreeSelect";

import styles from "./AuditoriaFilterPanel.module.scss";

// let appliedEnabled = false;

const useStyles = makeStyles(theme => ({
  formControl: {
    width: "250px",
    position: "relative"
  },
  inputLabel: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    backgroundColor: "transparent",
    border: "none"
  },
  select: {
    "& .MuiSelect-icon": {
      transform: "translateY(90%)"
    }
  },
  outlinedInput: {
    paddingRight: "32px"
  },
  menuItemText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: isMobile ? "calc(60% - 100px)" : "370px",
      minWidth: isMobile ? "288px" : "260px",
      maxWidth: isMobile ? "50vw" : "200px",
      transform: isMobile ? "translateX(-2px)" : "translateX(18px)"
    }
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left"
  }
};

const AuditoriaFilterPanel = ({
  activeStatus = undefined,
  activeModifiedTrue = undefined,
  activeModifiedFalse = undefined,
  activeDateFrom = undefined,
  activeDateTo = undefined,
  handleApplyProp,
  opened = false,
  stock = 0,
  handleOpen,
  handleDeleteProp,
  fixedButtons = false,
  handleSelectionChange = () => {},
  showFilters,
  showModifiedFilter = false,
  showStatusFilter = false,
  showDateFilter = false,
  // callbacks to notify parent when these controls change
  filterProducts = () => Promise.resolve([]),
  handleSelectionChangeCategory,
  handleSelectionChangeProduct,
  selectedProducts = [],
  categoriesTree,
  clear,
  setPage = () => {},
  closeMobilePanel = () => {}
}) => {
  const [filters, setFilters] = useState(filterData);
  const [msgNotZone, setMsgNotZone] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [listId, setListId] = useState([]);
  const [appliedEnabled, setAppliedEnabled] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  // local state for the optional controls
  const [modifiedSelected, setModifiedSelected] = useState([]); // values: true / false
  const [statusSelected, setStatusSelected] = useState([]); // values: 'completo'|'incompletos'|'all'
  const [dateRange, setDateRange] = useState([null, null]);

  const createDateWithoutTimezoneShift = dateString => {
    if (!dateString) return null;

    const parts = dateString.split("-");

    const year = parseInt(parts[0], 10);
    const monthIndex = parseInt(parts[1], 10) - 1;
    const day = parseInt(parts[2], 10);

    return new Date(year, monthIndex, day);
  };

  // Synchronize the local state with the active props of the parent.
  // This is only activated if the parent (ViewStockAudit) is passing the active filter props.
  useEffect(() => {
    // If none of the active filter props are defined, we assume that this
    // component is used by the other parent (CreateStockAudit) and we do nothing.
    if (
      activeStatus === undefined &&
      activeModifiedTrue === undefined &&
      activeDateFrom === undefined
    ) {
      return;
    }

    const newModifiedSelected = [];
    if (activeModifiedTrue === true) newModifiedSelected.push(true);
    if (activeModifiedFalse === true) newModifiedSelected.push(false);

    // We only update if there is a real change or if it was deleted.
    const shouldUpdateModified =
      activeModifiedTrue !== undefined || activeModifiedFalse !== undefined;
    if (shouldUpdateModified) {
      setModifiedSelected(newModifiedSelected);
    }

    let newStatusSelected = [];
    if (activeStatus === true) {
      newStatusSelected = ["c"];
    } else if (activeStatus === false) {
      newStatusSelected = ["i"];
    } else {
      newStatusSelected = [];
    }

    if (activeStatus !== undefined) {
      setStatusSelected(newStatusSelected);
    }

    if (activeDateFrom !== undefined || activeDateTo !== undefined) {
      const newDateFrom = createDateWithoutTimezoneShift(activeDateFrom);
      const newDateTo = createDateWithoutTimezoneShift(activeDateTo);

      setDateRange([newDateFrom, newDateTo]);
    }

    setAppliedEnabled(false);
  }, [
    activeStatus,
    activeModifiedTrue,
    activeModifiedFalse,
    activeDateFrom,
    activeDateTo
  ]);

  // Get Sucursales at the start
  useEffect(() => {
    BusinessNodeService.businessNodes({ no_page: 1 }).then(nodes => {
      nodes = nodes.map(n => {
        n.id = n.code;
        n.label = n.name;
        n.value = n.name;
        return n;
      });

      filterData[0].options = nodes;
      filterData[1].options = [];
      filterData[2].options = [];
      setFilters(filterData);
    });
  }, []);

  const handleFilterProducts = value => {
    if (!value || value.length <= 2) {
      setFilteredProducts([]);
      return;
    }
    try {
      const result = filterProducts(value);
      if (result && typeof result.then === "function") {
        result
          .then(res => setFilteredProducts(res || []))
          .catch(() => setFilteredProducts([]));
      } else {
        setFilteredProducts(result || []);
      }
    } catch (e) {
      setFilteredProducts([]);
    }
  };

  const formatDate = d => {
    if (!d) return null;
    if (typeof d === "string") return d;
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const handleApply = selectedOption => {
    // build payload with all filters so parent can apply atomically
    const modifiedTrue = modifiedSelected.includes(true);
    const modifiedFalse = modifiedSelected.includes(false);

    // statusSelected stores option ids (see onStatusSelection).
    let statusValue = undefined;
    if (statusSelected.length === 0) {
      statusValue = undefined;
    } else if (statusSelected.includes("c")) {
      statusValue = true;
    } else if (statusSelected.includes("i")) {
      statusValue = false;
    }

    const start = dateRange[0] ?? null;
    const end = dateRange[1] ?? null;
    const payload = {
      selectedOptions: selectedOption,
      status: statusValue,
      modifiedTrue,
      modifiedFalse,
      date_from: formatDate(start),
      date_to: formatDate(end)
    };

    // notify parent once with complete payload
    handleApplyProp(payload);
    // after applying, disable apply until further changes
    setAppliedEnabled(false);
  };

  //Save selection
  const handleSelection = (option, label) => {
    const index = filters.findIndex(f => f.label === label);
    if (index === 0) {
      getZones(option.code);
      const _selectedOptions = [option, {}, {}];
      setSelectedOptions(_selectedOptions);
      setAppliedEnabled(true);
    }

    if (index === 1) {
      setAppliedEnabled(true);
      getAreas(option.id);
      const _selectedOptions = [selectedOptions[0], option, {}];
      setSelectedOptions(_selectedOptions);
    }

    if (index === 2) {
      setAppliedEnabled(true);
      const _selectedOptions = [...selectedOptions];
      _selectedOptions[2] = option;
      setSelectedOptions(_selectedOptions);
    }
    // call parent's handler; include label for context if parent expects it
    handleSelectionChange(option, label);
  };

  // handlers for the optional controls
  const onModifiedSelection = (option, operation, label) => {
    // option.value expected true|false
    let newSel = [...modifiedSelected];
    if (operation === "add") {
      newSel.push(option.value);
    } else if (operation === "delete") {
      newSel = newSel.filter(v => v !== option.value);
    } else if (operation === "deleteAll") {
      newSel = [];
    }
    newSel = Array.from(new Set(newSel));
    setModifiedSelected(newSel);

    // enable apply when modified selection exists or locations selected or user explicitly clicked "all"/deleteAll
    const explicitSelection = operation === "add" || operation === "deleteAll";
    setAppliedEnabled(
      explicitSelection ||
        newSel.length > 0 ||
        (selectedOptions &&
          selectedOptions.some(o => o && Object.keys(o).length > 0))
    );
  };

  // status selection handler used by DropdownFilter
  const onStatusSelection = (option, operation, label) => {
    // guardamos los ids (option.id = 'c'|'i'|'a') para que DropdownFilter pueda comparar por id
    let newSel = [...statusSelected];
    if (operation === "add") {
      newSel.push(option.id);
      // newSel.push(option.label);
    } else if (operation === "delete") {
      newSel = newSel.filter(v => v !== option.id);
      // newSel = newSel.filter(v => v !== option.label);
    } else if (operation === "deleteAll") {
      newSel = [];
    }
    newSel = Array.from(new Set(newSel));
    setStatusSelected(newSel);

    // enable apply when status selected or other selections present or user explicitly clicked "all"
    const explicit = operation === "add" || operation === "deleteAll";
    setAppliedEnabled(
      explicit ||
        newSel.length > 0 ||
        (selectedOptions &&
          selectedOptions.some(o => o && Object.keys(o).length > 0))
    );
  };

  const onDateChange = range => {
    const start = range[0] ?? null;
    const end = range[1] ?? null;
    setDateRange([start, end]);

    // do not call parent yet; only enable Apply
    const explicit = (start || end) !== null;
    setAppliedEnabled(
      explicit ||
        (selectedOptions &&
          selectedOptions.some(o => o && Object.keys(o).length > 0))
    );
  };

  const getZones = node => {
    LocationService.locationsAll({ no_parent: "true", node: node }).then(
      locations => {
        setMsgNotZone(
          locations.length === 0 ? i18n.t("no.areas.audit.in.this.branch") : ""
        );
        locations = locations.map(n => {
          n.label = n.name;
          n.value = n.name;
          return n;
        });
        const newFilters = [...filters];

        newFilters[1].options = locations;
        newFilters[2].options = [];
        setFilters(newFilters);
      }
    );
  };
  const getAreas = zone => {
    LocationService.locationsAll({ parent: zone }).then(locations => {
      locations = locations.map(n => {
        n.label = n.name;
        n.value = n.name;
        return n;
      });
      const newFilters = [...filters];

      newFilters[2].options = locations;
      setFilters(newFilters);
    });
  };

  const handleDelete = () => {
    setIsDeleting(true);
    setSelectedOptions([]);
    // clear optional filters
    setModifiedSelected([]);
    setStatusSelected([]);
    setDateRange([null, null]);
    setListId();
    setFilteredProducts([]);
    setFilters(prev => {
      const fd =
        prev && Array.isArray(prev)
          ? [...prev]
          : [
              {
                type: "dropdown",
                options: [],
                label: i18n.t("sucursal") || "Sucursal",
                firstOptionLabel: i18n.t("all"),
                name: "branch"
              },
              {
                type: "dropdown",
                options: [],
                label: i18n.t("zona") || "Zona",
                firstOptionLabel: i18n.t("all"),
                name: "zone"
              },
              {
                type: "dropdown",
                options: [],
                label: i18n.t("sector") || "Sector",
                firstOptionLabel: i18n.t("all"),
                name: "area"
              }
            ];
      if (fd[1]) fd[1] = { ...fd[1], selectedOption: null, options: [] };
      if (fd[2]) fd[2] = { ...fd[2], selectedOption: null, options: [] };

      return fd;
    });

    // Clear any "zone not found" messages
    setMsgNotZone("");

    // Notify parent with explicit empty-payload so parent can run one request and reset its UI
    const payload = {
      selectedOptions: [],
      status: undefined,
      modifiedTrue: false,
      modifiedFalse: false,
      date_from: null,
      date_to: null,
      clear: true
    };

    handleDeleteProp(payload);

    setPage(1);

    setAppliedEnabled(false);
  };

  useEffect(() => {
    if (isDeleting) {
      setIsDeleting(false);
    }
  }, [isDeleting, setPage]);

  const statusOptions = [
    { id: "c", label: "completo" },
    { id: "i", label: "incompletos" }
  ];

  return (
    <div className={styles[`auditoria-filter-panel-container-out`]}>
      {!opened && isMobile && (
        <div className={styles[`auditoria-filter-panel-summary`]}>
          <div className={styles[`auditoria-filter-panel-summary-row`]}>
            <div className={styles[`auditoria-filter-panel-summary-filters`]}>
              {filters?.map((filter, i) => {
                return (
                  selectedOptions[i]?.label && (
                    <div key={i}>
                      <div>
                        {filter.label} {selectedOptions[i].label}
                      </div>
                      <div className={"separator"}></div>
                    </div>
                  )
                );
              })}
            </div>
            <div
              className={styles[`auditoria-filter-panel-summary-button`]}
              onClick={handleOpen}
            >
              <i className={`icon-iconos_filtros`} />
            </div>
          </div>
          <div className={styles[`auditoria-filter-panel-summary-row`]}>
            <p className={styles["auditoria-filter-panel-summary-stock"]}>
              Stock({stock})
            </p>
          </div>
        </div>
      )}

      {(opened || !isMobile) && (
        <div
          className={`${styles[`auditoria-filter-panel-container`]} ${
            fixedButtons ? styles["fixed-buttons"] : ""
          }`}
        >
          {opened && isMobile && (
            <div className={styles["mobile-panel-header"]}>
              <div
                className={styles["back-button-container"]}
                onClick={closeMobilePanel}
              >
                <i className={`icon-chevron ${styles["back-icon"]}`} />
                <span className={styles["back-text"]}>{i18n.t("go.back")}</span>
              </div>
            </div>
          )}

          <div className={styles[`auditoria-filter-panel-inputs`]}>
            {/* Filtro de Locations */}
            {filters?.map((filter, i) => {
              if (filter.options && filter.options?.length > 0) {
                return (
                  <div
                    key={filter.label}
                    className={styles["dropdown-filter-container"]}
                  >
                    <SelectFilter
                      label={filter.label}
                      options={filter.options}
                      selectedOption={selectedOptions?.[i] || null}
                      handleSelection={e => handleSelection(e, filter.label)}
                      placeholder={filter.placeholder}
                    />
                  </div>
                );
              }
            })}

            {/* Filtros adicionales debajo de Locations */}
            <div
              className={styles[`auditoria-filter-panel-additional-filters`]}
            >
              {showDateFilter && (
                <div className={styles[`dropdown-filter-container`]}>
                  <DateInput
                    label={i18n.t("date.range")}
                    selectedDates={[dateRange[0], dateRange[1]]}
                    handleChange={r => onDateChange(r)}
                  />
                </div>
              )}

              {showStatusFilter && (
                <div className={styles[`dropdown-filter-container`]}>
                  <DropdownFilter
                    label={i18n.t("status")}
                    options={statusOptions}
                    firstOptionLabel={i18n.t("all")}
                    selectedOptions={statusSelected.map(id => {
                      const opt = statusOptions.find(o => o.id === id);
                      return { id, label: opt ? opt.label : id };
                    })}
                    handleSelection={onStatusSelection}
                  />
                </div>
              )}

              {showModifiedFilter && (
                <div className={styles[`two-option-filter-container`]}>
                  <TwoOptionFilter
                    options={[
                      { label: i18n.t("modified"), value: true },
                      { label: i18n.t("no.modified"), value: false }
                    ]}
                    selectedOptions={modifiedSelected.map(v => ({
                      label: v ? i18n.t("modified") : i18n.t("no.modified"),
                      value: v
                    }))}
                    handleSelection={onModifiedSelection}
                    firstOptionLabel={i18n.t("all")}
                  />
                </div>
              )}
            </div>

            {/* Mensaje de "Not Zone" */}
            {msgNotZone && <div className="not-zones">{msgNotZone}</div>}

            {/* Filtros adicionales en móvil */}
            {isMobile && (
              <div
                className={styles[`auditoria-filter-panel-filtered-products`]}
              >
                <div className={styles[`auditoria-filter-categories-products`]}>
                  {showFilters && categoriesTree && categoriesTree.length > 0 && (
                    <div className={styles["combo-categories"]}>
                      <Container sx={{ height: "100vh", pt: 25 }}>
                        <DropDownTreeSelect
                          data={categoriesTree}
                          setListId={setListId}
                          listId={listId}
                          onChangeCategories={handleSelectionChangeCategory}
                          clear={clear}
                        />
                      </Container>
                    </div>
                  )}
                  {showFilters && filteredProducts?.length > 0 && (
                    <div className={styles["select-products-filter-wrapper"]}>
                      <FormControl
                        variant="outlined"
                        className={`${styles["formControl"]} ${styles["combo_products"]}`}
                      >
                        <Autocomplete
                          multiple
                          id="products-select-filled"
                          className={styles["products-autocomplete"]}
                          options={filteredProducts || []}
                          disableCloseOnSelect
                          getOptionLabel={option => option.label || ""}
                          onInputChange={(event, value) =>
                            handleFilterProducts(value)
                          }
                          onChange={(event, value) =>
                            handleSelectionChangeProduct(event, value)
                          }
                          renderOption={(props, option, { selected }) => {
                            const { key, ...optionProps } = props;
                            return (
                              <li key={option.id} {...optionProps}>
                                <Checkbox
                                  checked={selectedProducts
                                    .map(s => s.id)
                                    .includes(option.id)}
                                />
                                {option.label}
                              </li>
                            );
                          }}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip
                                label={option.label}
                                {...getTagProps({ index })}
                                className={styles["custom-chip"]}
                              />
                            ))
                          }
                          renderInput={params => (
                            <TextField
                              className={styles["products-textfield"]}
                              {...params}
                              label=""
                              placeholder={i18n.t("search.product")}
                            />
                          )}
                        />
                      </FormControl>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Botones Apply y Delete */}
          <div className={styles[`auditoria-filter-panel-buttons`]}>
            <button
              className={`${styles["auditoria-filter-panel-filter-apply"]}${
                !appliedEnabled ? ` ${styles["disabled"]}` : ""
              }`}
              disabled={!appliedEnabled}
              onClick={() => handleApply(selectedOptions)}
            >
              {i18n.t("apply").toUpperCase()}
            </button>
            <button
              className={styles["auditoria-filter-panel-filter-delete"]}
              onClick={handleDelete}
            >
              {i18n.t("delete").toUpperCase()}
            </button>
          </div>

          {/* Filtros para categorías y productos en Desktop */}
          <div className={styles[`auditoria-filter-categories-products`]}>
            {!isMobile &&
              showFilters &&
              categoriesTree &&
              categoriesTree.length > 0 && (
                <div className={styles["categories-tree"]}>
                  <Container sx={{ height: "100vh", pt: 25 }}>
                    <DropDownTreeSelect
                      data={categoriesTree}
                      setListId={setListId}
                      listId={listId}
                      onChangeCategories={handleSelectionChangeCategory}
                      clear={clear}
                    />
                  </Container>
                </div>
              )}

            {!isMobile && showFilters && filteredProducts?.length > 0 && (
              <FormControl
                variant="outlined"
                className={`${styles["formControl"]} ${styles["products-autocomplete"]}`}
              >
                <Autocomplete
                  multiple
                  id="products-select-filled"
                  options={filteredProducts || []}
                  disableCloseOnSelect
                  getOptionLabel={option => option.label || ""}
                  onChange={(event, value) =>
                    handleSelectionChangeProduct(event, value)
                  }
                  style={{ width: 500 }}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option.label}
                        {...getTagProps({ index })}
                        className={styles["custom-chip"]}
                      />
                    ))
                  }
                  renderInput={params => (
                    <TextField
                      className={styles["products-textfield"]}
                      {...params}
                      label=""
                      placeholder={i18n.t("search.product")}
                    />
                  )}
                />
              </FormControl>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AuditoriaFilterPanel;
